import { Select } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { useGetRollersQuery } from '../../../store/api/rollers-api'
import { requiredOneElementRules } from '../../../constants/forms/validation/rules'
import { formatRollerDisplay } from '../../../helpers/format-roller-display'
import { Rule } from 'antd/es/form'

interface RollerProps {
    noStyle?: boolean
    rules?: Rule[]
}

const Roller: FC<RollerProps> = ({ noStyle, rules = requiredOneElementRules }) => {
    const name = 'roller'
    const { data } = useGetRollersQuery()

    return (
        <Form.Item name={name} label={'Вал'} rules={rules} noStyle={noStyle}>
            <Select
                style={{ width: '100%' }}
                options={data?.data.map(item => ({
                    value: item.documentId,
                    label: formatRollerDisplay(item.roller),
                }))}
                allowClear
            />
        </Form.Item>
    )
}

export default Roller
